import React from 'react';
import Icon from '../../../components/AppIcon';

const HeatMapView = ({ data }) => {
  const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  const hours = ['6AM', '9AM', '12PM', '3PM', '6PM', '9PM'];

  if (!data || data?.length === 0) {
    return (
      <div className="h-64 flex items-center justify-center text-muted-foreground text-sm">
        No heat map data available
      </div>
    );
  }

  const getIntensityColor = (value) => {
    if (value >= 80) return 'bg-success';
    if (value >= 60) return 'bg-success/70';
    if (value >= 40) return 'bg-warning/70';
    if (value >= 20) return 'bg-warning/40';
    return 'bg-muted';
  };

  const getIntensityLabel = (value) => {
    if (value >= 80) return 'Very High';
    if (value >= 60) return 'High';
    if (value >= 40) return 'Medium';
    if (value >= 20) return 'Low';
    return 'Very Low';
  };

  return (
    <div>
      <div className="mb-4 flex items-center gap-4 text-xs text-muted-foreground">
        <span>Check-in Completion Rate:</span>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 rounded bg-muted"></div>
          <span>Very Low</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 rounded bg-warning/40"></div>
          <span>Low</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 rounded bg-warning/70"></div>
          <span>Medium</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 rounded bg-success/70"></div>
          <span>High</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 rounded bg-success"></div>
          <span>Very High</span>
        </div>
      </div>
      <div className="overflow-x-auto">
        <div className="inline-block min-w-full">
          <div className="grid grid-cols-[80px_repeat(6,1fr)] gap-2">
            {/* Header Row */}
            <div></div>
            {hours?.map((hour) => (
              <div key={hour} className="text-xs font-medium text-muted-foreground text-center">
                {hour}
              </div>
            ))}

            {/* Data Rows */}
            {days?.map((day, dayIndex) => (
              <React.Fragment key={day}>
                <div className="text-xs font-medium text-muted-foreground flex items-center">
                  {day}
                </div>
                {hours?.map((hour, hourIndex) => {
                  const cellData = data?.find(
                    (d) => d?.day === dayIndex && d?.hour === hourIndex * 3 + 6
                  );
                  const value = cellData?.value || 0;
                  
                  return (
                    <div
                      key={`${day}-${hour}`}
                      className={`h-12 rounded-lg ${getIntensityColor(value)} transition-smooth hover:scale-105 cursor-pointer relative group`}
                      title={`${day} ${hour}: ${value}% completion rate`}
                    >
                      <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-smooth">
                        <span className="text-xs font-medium text-white drop-shadow-lg">
                          {value}%
                        </span>
                      </div>
                    </div>
                  );
                })}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
      <div className="mt-6 p-4 bg-primary/5 rounded-lg border border-primary/20">
        <div className="flex items-start gap-3">
          <Icon name="Lightbulb" size={20} className="text-primary flex-shrink-0 mt-0.5" strokeWidth={2} />
          <div>
            <p className="text-sm font-medium text-foreground mb-1">
              Optimal Reminder Timing
            </p>
            <p className="text-xs text-muted-foreground">
              Based on historical data, check-in completion rates are highest on weekdays between 9AM-12PM. 
              Consider scheduling reminders during these peak engagement windows for better adherence.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeatMapView;